import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

const CustomModal = ({ handleOnClose, showModal, handleFormSubmit }) => {
  const [formTitle, setFormTitle] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef();
  const finalRef = React.useRef();

  const handleOnChange = (e) => {
    const value = e.target.value;
    setFormTitle(() => value);
  };

  useEffect(() => {
    if (showModal) {
      onOpen();
    }
  }, [showModal]);
  return (
    <Modal
      size="lg"
      initialFocusRef={initialRef}
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={(e) => handleOnClose(e, onClose)}
    >
      <ModalOverlay />
      <ModalContent max-width="512px" min-height="212px">
        <ModalHeader
          fontSize="18px"
          fontWeight="600"
          paddingBottom="12px"
          paddingLeft="32px"
          paddingTop="32px"
        >
          Name your form
        </ModalHeader>
        <ModalBody pb={4} pt={0} w={448} pl={0}>
          <FormControl>
            <FormLabel
              fontSize="12px"
              paddingLeft="33px"
              fontWeight="600"
              marginBottom="4px"
            >
              Form name
            </FormLabel>
            <Input
              value={formTitle}
              onChange={handleOnChange}
              ref={initialRef}
              placeholder="Form name"
              style={{
                marginLeft: "33px",
                marginRight: "33px",
                color: "#12344D",
                fontSize: "14px",
                fontWeight: "600",
                height: "32px",
                width: "420px",
              }}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter
          h="56px"
          style={{
            paddingRight: "0",
            backgroundColor: "#F5F7F9",
            borderRadius: "4px",
          }}
        >
          <Button
            width="72px"
            height="32px"
            borderRadius="4px"
            colorScheme="secondary"
            className="btn--secondary"
            onClick={(e) => handleOnClose(e, onClose)}
          >
            Cancel
          </Button>
          <Button
            width="107px"
            height="32px"
            borderRadius="4px"
            marginLeft="12px"
            marginRight="16px"
            colorScheme="primary"
            className="btn--primary"
            onClick={(e) => handleFormSubmit(e, formTitle)}
          >
            Create Form
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
CustomModal.propTypes = {
  handleOnClose: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
};
export default CustomModal;
